import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeHalf: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVolumeHalf"><Path d="M13 2.97046V21.0296L5.8043 17.0001H1V7.00005H5.8043L13 2.97046Z" fill="currentColor"/><Path d="M15.3588 8.64172C16.2192 9.50212 16.75 10.6886 16.75 12.0005C16.75 13.3124 16.2192 14.4988 15.3588 15.3592L16.4194 16.4199C17.5496 15.2897 18.25 13.7262 18.25 12.0005C18.25 10.2748 17.5496 8.71126 16.4194 7.58105L15.3588 8.64172Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVolumeHalf;
